export interface LegStats {
  distanceKm: number;
  gainM: number;
  lossM: number;
}

// Для каждой контрольной точки профиля - длина, набор и спуск от предыдущей
// точки (или от старта маршрута для первой). Результат выровнен с `markers`
// по индексу; порядок маркеров во входе не важен.
export function legStats(
  points: { distance_km: number; elevation_m: number }[],
  markers: { distance_km: number }[],
): LegStats[] {
  return markers.map((m) => {
    const prev = markers.reduce((best, o) => (o.distance_km < m.distance_km && o.distance_km > best ? o.distance_km : best), 0);
    let gainM = 0;
    let lossM = 0;
    for (let i = 1; i < points.length; i++) {
      const end = points[i].distance_km;
      if (end <= prev || end > m.distance_km) continue;
      const d = points[i].elevation_m - points[i - 1].elevation_m;
      if (d > 0) gainM += d;
      else lossM -= d;
    }
    return { distanceKm: Math.max(m.distance_km - prev, 0), gainM, lossM };
  });
}
